
import iro from '@jaames/iro'
import { defineComponent, PropType } from 'vue'
import AppointmentTypeService from '../common/appointmentTypeService'
import { AppointmentType } from '../models/appointmentType'

export default defineComponent({
  name: 'AppointmentTypeForm',

  props: {
    /** The appointment type to edit */
    appointmentType: {
      type: Object as PropType<AppointmentType>,
      required: false
    },

    /** is appointment type being edited */
    editing: {
      type: Boolean,
      default: false,
      required: false
    },

    /** Indicates if the modal is visible or not */
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data () {
    return {
      /** The working copy of the appointment type to edit/create */
      editForm: {} as AppointmentType
    }
  },

  computed: {
    /** Indicaves if a type is being edited or created */
    isEditing (): boolean {
      return this.appointmentType !== null
    },

    /** indicates if appointment type is valid */
    isValid (): boolean {
      if (!this.visible) {
        return false
      }

      if (this.editForm.name === '' || this.editForm.description === '' || this.editForm.duration === 0 || (this.editForm.duration as any) === '') {
        return false
      }

      return true
    }
  },

  watch: {
    visible: {
      handler (val) {
        if (!val) {
          return
        }

        this.resetForm()

        setTimeout(() => {
          const colorPicker = iro.ColorPicker('#color-picker', {
            width: 120,
            color: this.appointmentType ? this.appointmentType.color : '#CCC'
          })

          colorPicker.on(['color:init', 'color:change'], this.setColor)
        }, 0)
      }
    }
  },

  emits: ['close', 'updated'],

  methods: {
    /**
     * Emits an event to close the modal
     */
    close () {
      this.$emit('close')
    },

    /**
     * Creates a new AppoiontmentType
     */
    createAppointmentType () {
      AppointmentTypeService.create(this.editForm).then(res => {
        this.$emit('updated', res.data)
      })
    },

    /**
     * Updates the appointment types's general info
     */
    editAppointmentType () {
      AppointmentTypeService.update(this.editForm).then(res => {
        this.$emit('updated', res.data)
      })
    },

    /**
     * Resets the edit form to default values
     */
    resetForm () {
      this.editForm = {
        id: this.appointmentType ? this.appointmentType.id : 0,
        name: this.appointmentType ? this.appointmentType.name : '',
        description: this.appointmentType ? this.appointmentType.description : '',
        duration: this.appointmentType ? this.appointmentType.duration : 60,
        public: this.appointmentType ? this.appointmentType.public : false,
        isTask: this.appointmentType ? this.appointmentType.isTask : false,
        removed: this.appointmentType ? this.appointmentType.removed : false,
        color: this.appointmentType ? this.appointmentType.color : ''
      }
    },

    /**
     * Sets the edif form's color field with the given color
     * @param color: The color object from iro picker
     */
    setColor (color) {
      this.editForm.color = color.hexString
    }
  }
})
